export default __webpack_public_path__ + "static/media/mysql.22c31216.jfif";